export enum TipoBuscaSolicitacaoClassificacaoEnum {
    NORMAL,
    VISIBILIDADE,
}
